var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2316_9051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.13855 9.86125V3.15625H1.23298C0.689883 3.15625 0.25 3.59464 0.25 4.13589V12.7689C0.25 13.3096 0.689883 13.7486 1.23298 13.7486H9.89549C10.4386 13.7486 10.8785 13.3096 10.8785 12.7689V11.8205H4.10451C3.02016 11.8205 2.13855 10.9413 2.13855 9.86125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6455 0.25H3.98298C3.43988 0.25 3 0.688387 3 1.22964V9.86268C3 10.4033 3.43988 10.8423 3.98298 10.8423H12.6455C13.188 10.8423 13.6285 10.4033 13.6285 9.86268V1.22964C13.6285 0.688387 13.188 0.25 12.6455 0.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4893 9.00195H9.61914L8.41309 6.72168C8.36751 6.63704 8.32031 6.48079 8.27148 6.25293H8.25195C8.22917 6.36035 8.17546 6.52311 8.09082 6.74121L6.87988 9.00195H5L7.23145 5.50098L5.19043 2H7.10938L8.11035 4.09961C8.18848 4.26562 8.25846 4.46257 8.32031 4.69043H8.33984C8.37891 4.55371 8.45215 4.35026 8.55957 4.08008L9.67285 2H11.4307L9.33105 5.47168L11.4893 9.00195Z",
    fill: "#26A96C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2316_9051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5,
    height: 13.5,
    fill: "white",
    transform: "translate(0.25 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default ForwardRef;